var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SessionContainer"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"view",on:{"game-session-done":_vm.onDone}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }